module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/og-coj_e-8621ce890f1c1a749464598b70e13845.png";